module.exports = __webpack_public_path__ + "static/Pour-8bfd072fd11c348a799946b1f0a6e3f5.jpg";